module.exports = __webpack_public_path__ + "img/thumbs-up-off.b1e3c472.svg";